import { createReducer } from '@reduxjs/toolkit';
import { metaActions } from '../actions/meta.actions';
import { conversationsActions } from '../actions/conversations.actions';
import { accountActions } from '../actions/account.actions';

const defaultState = {};

const reset = () => defaultState;

const setConversations = (state, action) => {
  const conversationList = action?.payload ?? [];

  return conversationList.reduce((acc, conv) => {
    acc[conv.id] = conv;
    return acc;
  }, {});
};

const setConversationsMessages = (state, action) => {
  const messages = action?.payload ?? [];

  if (!messages.length) return state;

  const conversationId = messages[0].conversationId;
  return {
    ...state,
    [conversationId]: {
      ...state[conversationId],
      messages,
    },
  };
};

const updateConversationsReactions = (state, action) => {
  const conversationReaction = action?.payload;

  if (!conversationReaction) return state;

  const { conversationId, ...reactions } = conversationReaction;
  return {
    ...state,
    [conversationId]: {
      ...state[conversationId],
      reactedLike: reactions.like,
      reactedGreatIdea: reactions.greatIdea,
      reactedWorkingOnIt: reactions.workingOnIt,
    },
  };
};

const updateConversationsMessage = (state, action) => {
  const conversationMessage = action?.payload;

  if (!conversationMessage) return state;

  const conversationId = conversationMessage.conversationId;
  const conversation = state[conversationId];
  conversation.messages.push(conversationMessage);

  return state;
};

const conversations = createReducer(defaultState, (builder) => {
  builder.addCase(metaActions.reset, reset);
  builder.addCase(conversationsActions.fetchConversationList.fulfilled, setConversations);

  builder.addCase(conversationsActions.fetchConversationMessages.fulfilled, setConversationsMessages);

  builder.addCase(conversationsActions.updateConversationReaction.fulfilled, updateConversationsReactions);

  builder.addCase(conversationsActions.addConversationMessage.fulfilled, updateConversationsMessage);

  builder.addCase(conversationsActions.resetConversationsPageStates, reset);
  builder.addCase(accountActions.switchCompany.pending, reset);
});

export default conversations;
